import './index.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tooltip, OverlayTrigger } from 'ui';
import { renderError } from 'services/gecko-error';
import CONSTS from 'constants/index.js';
import ImportReviewService from '../Service';
import { fetchImportDeltas } from '../../../../actions';

export class DeltaActions extends Component {
  approve() {
    if (
      this.props.delta.review_status !== CONSTS.DELTA_REVIEW_STATUS_NOT_REVIEWED
    )
      return;

    return ImportReviewService.approve(
      this.props.botId,
      this.props.importId,
      this.props.delta
    )
      .then(() => {
        // Fetch Deltas
        fetchImportDeltas({
          botId: this.props.botId,
          importId: this.props.importId,
          page: this.props.page,
        });
      })
      .catch(renderError);
  }

  reject() {
    if (
      this.props.delta.review_status !== CONSTS.DELTA_REVIEW_STATUS_NOT_REVIEWED
    )
      return;

    return ImportReviewService.reject(
      this.props.botId,
      this.props.importId,
      this.props.delta
    )
      .then(() => {
        // Fetch Deltas
        fetchImportDeltas({
          botId: this.props.botId,
          importId: this.props.importId,
          page: this.props.page,
        });
      })
      .catch(renderError);
  }

  renderId(type) {
    return `bot-answer-import-review-actions-${type}-${this.props.deltaId}`;
  }

  renderActions() {
    return (
      <div
        className="DeltaActions"
        onClick={(event) => event.stopPropagation()}
      >
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id={this.renderId('approve')}>Approve</Tooltip>}
        >
          <i
            className={`far fa-check`}
            id={this.renderId('approve')}
            onClick={this.approve.bind(this)}
          ></i>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id={this.renderId('reject')}>Reject</Tooltip>}
        >
          <i
            className="far fa-times"
            id={this.renderId('reject')}
            onClick={this.reject.bind(this)}
          ></i>
        </OverlayTrigger>
      </div>
    );
  }

  renderApproved() {
    return (
      <div className="DeltaActions">
        <i className="far fa-check"></i>
      </div>
    );
  }

  renderRejected() {
    return (
      <div className="DeltaActions">
        <i className="far fa-times"></i>
      </div>
    );
  }

  render() {
    switch (this.props.delta.review_status) {
      case CONSTS.DELTA_REVIEW_STATUS_APPROVED:
        return this.renderApproved();
        break;
      case CONSTS.DELTA_REVIEW_STATUS_REJECTED:
        return this.renderRejected();
        break;
      case CONSTS.DELTA_REVIEW_STATUS_NOT_REVIEWED:
        return this.renderActions();
        break;
    }
  }
}

const mapStateToProps = (state, props) => {
  return {
    page: state.botsRoute.deltas.page,
    delta: state.botsRoute.deltasById[props.deltaId],
  };
};

export default connect(mapStateToProps)(DeltaActions);
